export const attrBelt = {
    percentage : [75,17, 8],
    color: [0x808080, 0x8B4513,0x696969],
    size: [3e-6, 7e-6, 1.5e-5]
} 

export const attrKuiper = {
    percentage : [75, 17, 8],
    color: [0x808080, 0x8B4513,0xd3d3d3],
    size: [8e-6, 4e-6, 1e-5] 
}
export const formatKuiper = {
    r : 234.712,
    R: 704.135 ,
    thetaSet: 1.4,
    phiSet:0.34
}

export const formatBelt = {
    r : 22.66,
    R: 52.35,
    thetaSet: 2,
    phiSet:0.8,
    circle:1
}

export const attrOort = {
    percentage : [88,12.95, 0.05],
    color: [0xffC0C0, 0x8B4513,0x696969],
    size: [1e-5, 2.5e-5, 0.87e-4]
}

// export const attrStars = {
//     percentage: [74.9999, 2, 3, 8, 12, 0.0001],
//     color: [0x87CEEB, 0xFFFFFF, 0xFFF176, 0xFFA726, 0xFF7043, 0xFF5252],
//     size: [   
//       1.0929e-1 * 0.4,
//       1.0929e-1 * 0.8,
//       1.0929e-1 * 1,
//       1.0929e-1 * 1.3,
//       1.0929e-1 * 10,
//       1.0929e-1 * 20,
//     ]
//   };


export const attrNebulas = {
  percentage: [60, 10, 20, 5, 5],
  color: [
    0xFF0000, 
    0x6CA0DC, 
    0x40E0D0, 
    0xFF8C00, 
    0x2F4F4F  
  ],
};

export const attrNebNeutron = {
  percentage: [70, 30],
  color: [ 0x6CA0DC, 0x40E0D0],
  size: [8e5, 6e5],
  format:{
    r : 3.5e4,
    R: 3.5e5 ,
    thetaSet: 2,
    phiSet:1.4},
  jets:{
  percentage: [30, 30],
  color: [ 0xfff222, 0xfff222],
  size: [8e9, 6e9],
  height: 1.6e6,
  collStrength: 1,
  collDecay:    0.1,   

}

};








export const attrNebSarg = {
  percentage: [50, 30, 20],
  color: [0xFF4500, 0x6CA0DC, 0xFFD700],
  size: [1e7, 8e6, 6e6],
  format:{
    r : 3e5,
    R: 3e6 ,
    thetaSet: 2,
    phiSet:1.4
}
};

export const attrStars = {
    percentage: [74.9999, 2, 3, 8, 12, 0.0001],
    color: [0x87CEEB, 0xFFFFFF, 0xFFF176, 0xFFA726, 0xFF7043, 0xFF5252],
    size: [   
      1.0929e-1 * 0.3,
      1.0929e-1 * 0.5,
      1.0929e-1 * 0.73,
      1.0929e-1 * 1.1,
      1.0929e-1 * 1.6,
      1.0929e-1 * 1.3,
    ]
  };

export const attrTailDust = {
    percentage : [75,17, 8],
    color: [0xfff0f0, 0x2fffff,0xfFFFd0],
    size: [6e-1, 6e-1, 6e-1]
}
export const attrTailGas = {
    percentage : [75,17, 8],
    color: [0x0e4eaf,0xBDF6FE,0xAFEEEE],
    size: [6e-1, 6e-1, 6e-1]
}


export const attrNeutron = {
  percentage: [70, 20, 10],            
  color: [
    0xFFFFFF,  
    0x0033FF,   
    0x66CCFF  
  ],
  size: [1, 1, 1],
  jetConfig:{
      lengthFactor:        350,
      speedFactor:         0.005,
      inclinationAngle:    Math.PI / 6,
      minSize:             0.015,
      minOpacity:          0.2,
      rotationStrength:    0.0,
      rotationDecay:       0,      
      collimationStrength: 1,
      collimationDecay:    0.1,    
      respawnProb: 1.0,
      opacityGlob:1.0      
    }
};

export const attrSagittarius = {
  percentage: [60, 30, 10],
  color: ['0xFF4500', '0xADFF2F', '0xFFF4E6'],
  size: [1, 1, 1],
  jetConfig: {
    lengthFactor:        50,
    speedFactor:         0.5,
    inclinationAngle:    0,
    minSize:             6,
    minOpacity:          0.02,
    rotationStrength:    1,
    rotationDecay:       0.2,
    collimationStrength: 2,
    collimationDecay:    0.1,
    respawnProb:         1.0,
    opacityGlob:0.2
  }
};


